import en from './translations/translations.neutral.json';
import en_GB from './translations/translations.en-GB.json';
import en_IE from './translations/translations.en-IE.json';

export const resources = {
  en: en,
  'en-GB': en_GB,
  'en-IE': en_IE,
};

export const supportedLocales = Object.keys(resources);
